// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-module_spinner-M5YbB","spinner-rotate":"spinner-module_spinner-rotate-ymBrr"};